export const tableDataSchemas = [
  {
    prop: 'name',
    label: '类别名称',
    minWidth: 120
  },
  {
    prop: 'type',
    label: '应用类型',
    minWidth: 120
  }
]

// 基础设置 form
export const formSchemas = [
  {
    field: 'name',
    defaultValue: '',
    component: 'Input',
    label: '应用配置名称',
    placeholder: '请输入应用配置名称',
    rules: [
      {
        required: true,
        message: '应用配置名称不能为空',
        trigger: ['blur']
      }
    ]
  },
  {
    field: 'type',
    defaultValue: 1,
    component: 'Radio',
    label: '系统类型',
    radioArr: [
      {
        label: '前台app应用',
        value: 1
      },
      {
        label: '后台管理系统应用',
        value: 2
      }
    ]
  },
  {
    field: 'appType',
    defaultValue: '',
    component: 'Radio',
    label: '应用类型',
    radioArr: [
      {
        label: '咨询师应用',
        value: 1
      },
      {
        label: '患者应用',
        value: 2
      },
      {
        label: '医生应用',
        value: 3
      },
      {
        label: 'h5患者应用',
        value: 4
      }
    ]
  }
]

// 修改设置 form
export const updateFormSchemas = [
  {
    field: 'displayName',
    defaultValue: '',
    component: 'Input',
    label: '默认显示名称',
    placeholder: '请填写默认显示名称',
    rules: [
      {
        required: true,
        message: '默认显示名称不能为空',
        trigger: ['blur']
      }
    ]
  }
]

export const options = []
